import { validateConversationGroup } from './groupConversations';
export async function sendNewGroupText({ orgId, groupPhones, identity, body, mediaUrl, signature, sendingIdentityExplicitlyChosen, sendReply, signBody, loadThread } = {}) {
    const validation = validateConversationGroup(groupPhones);
    if (!validation.valid) throw new Error(validation.error);
    if (mediaUrl) throw new Error('Group text attachments are not available yet. Send a text-only group message.');
    const signed = await signBody({ body, channel: 'sms', signature });
    const result = await sendReply({ orgId, groupAddresses: validation.phones, channel: 'sms', body: typeof signed === 'string' ? signed : (signed?.body || body),
        sendingIdentityId: identity?.sourceId || identity?.id, sendingIdentityExplicitlyChosen });
    if (!result?.sent) throw new Error(result?.message || 'Delivery is being checked. Do not resend.');
    return { thread: result.sessionId ? await loadThread(result.sessionId) : null, notice: 'Group MMS sent.' };
}
